import {defineStore} from 'pinia'

/**
 * Signals to WorkflowFactory and bltForm1 that a review-modal edit section is open.
 * WorkflowFactory guards next()/previous() against navigation while isOpen is true.
 * bltForm1 hides the Continue button while isOpen is true.
 */
export const useApplicantReviewModeStore = defineStore('ApplicantReviewModeStore', {
  state: () => ({
    isOpen: false
  }),
  actions: {
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    }
  }
})
